// extracted by mini-css-extract-plugin
export default {"pageLink":"by_dB"};